import { render, staticRenderFns } from "./FormBuyForEntity.vue?vue&type=template&id=2743b3ac&scoped=true"
import script from "./FormBuyForEntity.vue?vue&type=script&lang=ts"
export * from "./FormBuyForEntity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2743b3ac",
  null
  
)

export default component.exports